const SouscriptionCustomerGranteesExtraForm = () => null;

export default SouscriptionCustomerGranteesExtraForm;
